// TODO columns should come from BE
// const dataStructure = {
//   key: "",
//   order: 0,
//   label: "",
//   enableResizing: true,
//   enableSorting: true,
//   size: 200,
// };
import StatusBadge from "@/components/StatusBadge";

import React from "react";

export const columns = () => {
  return [
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ row }) => <StatusBadge status={row.getValue("status")} />,
    },
    {
      accessorKey: "sport.code",
      header: "Sport ID",
    },
    {
      accessorKey: "code",
      header: "ID",
      cell: ({ row }) => <div>{row.getValue("code")}</div>,
    },
    {
      accessorKey: "product_class.code",
      header: "Product Class ID",
    },
  ];
};
